package com.essntl.uikit.components.chat.group

import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon

@Composable
fun GroupAvatar() {
    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .size(40.dp)
            .border(
                width = 1.dp,
                color = Color(0xFF3a88fe),
                shape = CircleShape,
            )
            .clip(CircleShape),
    ) {
        EsLargeIcon(
            res = EsIcons.Group,
            tint = Color(0xFF3a88fe),
        )
    }
}